import React from "react";
import { Image } from "react-bootstrap";
import _costIcon from "../../assets/project-cost-state.png";
import _projectIcon from "../../assets/project-count-state.png";
import { formatNumberOnDashBoard } from "../../helper";

function MapStateDataRender(props) {
  const { stateData, stateName } = props;
  return (
    <React.Fragment>
      <h2>{stateData.stateName ? stateData.stateName : stateName}</h2>
      <div className="state-content">
        <div className="project-stats">
          <div className="stats-img">
            <Image src={_projectIcon} alt="Projects" />
          </div>
          <div className="sector-stats">
            <b data-test="project-count">{stateData.projectCount || "0"}</b>{" "}
            Project(s)
          </div>
        </div>
        <div className="issue-stats">
          <div className="stats-img">
            <Image src={_costIcon} alt="Cost" />
          </div>
          <div className="sector-stats">
            <b data-test="project-investment">
              {stateData && stateData.projectCost
                ? formatNumberOnDashBoard(
                    Number(stateData.projectCost.toFixed(1)),
                    true,
                    true,
                    "."
                  )
                : "0"}
            </b>{" "}
            Project(s) Investment
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default MapStateDataRender;
